import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { IoIosArrowBack } from "react-icons/io";
import Banner from "./Components/Banner";
import { useTranslation } from 'react-i18next';
import useAnalytics from "../utils/useAnalytics";

const LandingPage = () => {
  const navigate = useNavigate();
  const { rest_name } = useParams();
  const [isLoading, setIsLoading] = useState({ main: false });
  const [restData, setRestData] = useState();
  const [menuData, setMenuData] = useState();
  const [beverageData, setBeverageData] = useState();
  const [showModalReg, setShowModalReg] = useState(false);
  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const logoUrl = import.meta.env.VITE_BACKEND_APP_STORAGE_URL;
  const logo = restData?.restaurant?.logo ? `${logoUrl}/${restData?.restaurant.logo}` : null;
  const [userType, setUserType] = useState('');
  const { t } = useTranslation();

  useAnalytics("G-VTBJ93ZEKJ"); 

  const getBeverageData = useCallback(async (restaurantId) => {
    try {
      setIsLoading(prev => ({ ...prev, main: true }));
      const res = await axios.get(`${apiUrl}/api/v1/category-beverages/${restaurantId}`);
      if (res.status === 200) {
        setBeverageData(res?.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(prev => ({ ...prev, main: false }));
    }
  }, [apiUrl]);

  const getRestData = useCallback(async () => {
    try {
      setIsLoading(prev => ({ ...prev, main: true }));
      const res = await axios.get(`${apiUrl}/api/v1/restaurant/${rest_name}`);
      if (res.status === 200) {
        setRestData(res?.data);
        getBeverageData(res?.data?.restaurant?.id);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(prev => ({ ...prev, main: false }));
    }
  }, [apiUrl, rest_name, getBeverageData]);

  const getMenuData = useCallback(async () => {
    try {
      setIsLoading(prev => ({ ...prev, main: true }));
      const res = await axios.get(`${apiUrl}/api/v1/restaurant-menus/${rest_name}`);
      if (res.status === 200) {
        setMenuData(res?.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(prev => ({ ...prev, main: false }));
    }
  }, [apiUrl, rest_name]);

  useEffect(() => {
    const role = localStorage.getItem("Role");
    setUserType(role)
  }, []);

  useEffect(() => {
    getRestData();
    getMenuData();
    getBeverageData();
  }, [rest_name, getRestData, getMenuData, getBeverageData]);

  return (
    <div className="flex flex-col w-full h-[100vh] overflow-y-scroll">
      <Banner
        desc={restData?.restaurant?.collaboration_description}
        restaurantId={restData?.restaurant?.id}
        restaurantName={restData?.restaurant?.restaurant_name}
        restData={restData}
        showModalReg={showModalReg}
        setShowModalReg={setShowModalReg}
        logo={logo}
      />
      {isLoading?.main ? (
        <div className="flex items-center justify-center h-full w-full">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          {!showModalReg && (
            <>
              {/* <div className="container max-w-[700px] m-auto px-[30px]">
                <div className=" flex justify-start lg:flex-row flex-col  items-center w-full gap-x-[100px] sm:mt-10 mt-5 sm:pb-[60px] pb-[30px] ">
                  {restData?.restaurant?.restaurant_name && (
                    <h1 className="spinja-font text-[#8B2433] text-center sm:text-[42px] text-[22px] font-medium leading-[42px] uppercase  border-b border-[#8B2433] sm:max-w-[430px] w-full pb-[12px] mt-4 mb-4">
                      {restData?.restaurant?.restaurant_name}
                    </h1>
                  )}
                  {logo && (
                    <img
                      src={logo}
                      className="w-[200px] sm:w-[230px] bg-cover mt-0"
                      alt="logo"
                    />
                  )}
                </div>
              </div> */}

              {/* Wine Listing */}
              <div className="container max-w-[700px] mx-auto px-[30px]">
                <div className="flex justify-around">
                  <h1 className=" spinja-font w-full text-left sm:text-[42px] text-[22px] font-medium leading-[26px] text-[#8B2433] border-t sm:pt-[50px] pt-[30px]">{restData?.restaurant?.wineListName || "Le nostre carte vini"}</h1>
                </div>
                <div className="w-full  pb-[40px] mt-5 py-3 flex items-center justify-start flex-wrap gap-4">
                  {restData?.wineList?.length > 0 ? (
                    restData?.wineList?.map((wine, index) => (
                      <div
                        key={index}
                        onClick={() => navigate(`/restaurant/${rest_name}/wine-list/${wine?.slug}`)}
                        className="spinja-font cursor-pointer px-[30px] py-[8px] shadow bg-[#EEDEE0] border-[#8B2433] text-center flex items-center justify-center rounded-[40px]"
                      >
                        <h1 className="spinja-font text-[17px] resto-first leading-[26px] break-words font-medium text-[#000000]">
                          {wine?.name}
                        </h1>
                      </div>
                    ))
                  ) : (
                    <div className="w-full p-6 text-center flex items-center justify-center">
                      Nessuna lista di vini disponibile
                    </div>
                  )}
                </div>
              </div>

              {/* Menu Listing */}
              {restData?.restaurant?.is_show_menu === 1 && (
                <div className="container max-w-[700px] mx-auto flex flex-col items-center justify-center px-[30px]">
                  <div className="flex justify-start gap-x-[200px] items-center w-full">
                    <h1 className="spinja-font w-full text-left sm:text-[42px] text-[22px] font-medium leading-[26px] text-[#8B2433] border-t sm:pt-[50px] pt-[30px]">{menuData?.restaurant?.menuListName || "I nostri menu"}</h1>
                  </div>

                  <div className="w-full mb-2 mt-5 py-3 flex items-center justify-start flex-wrap gap-4">
                    {menuData?.menus?.length > 0 ? (
                      menuData?.menus?.map((menu, index) => (
                        <div
                          key={index}
                          onClick={() => navigate(`/restaurant/${rest_name}/menu-list/${menu?.id}`)}
                          className="spinja-font cursor-pointer px-[30px] py-[8px] shadow bg-[#EEDEE0] border-[#8B2433] text-center flex items-center justify-center rounded-[40px]"
                        >
                          <h1 className="spinja-font text-[17px] resto-first leading-[26px] break-words font-medium text-[#000000]">
                            {menu?.name}
                          </h1>
                        </div>
                      ))
                    ) : (
                      <div className="w-full p-6 text-center flex items-center justify-center">
                        Nessun elenco di menu disponibile
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Beverage Listing */}
              {restData?.restaurant?.is_show_beverages === 1 && beverageData?.length > 0 && (

                <div className="container max-w-[700px] mx-auto flex flex-col items-center justify-center mb-5 px-[30px]">
                  {/* {beverageData?.length > 0 ? ( */}
                  <div className="flex justify-start gap-x-[200px] items-center w-full">
                    <h1 className="spinja-font w-full text-left sm:text-[42px] text-[22px] font-medium leading-[26px] text-[#8B2433] border-t sm:pt-[50px] pt-[30px] cursor-pointer hover:underline"
                      onClick={() => navigate(`/restaurant/${rest_name}/beverage-list/${restData?.restaurant?.id}`)}
                    >{restData?.restaurant?.beverageListName || "Altre Bevande"}</h1>
                  </div>
                  {/* ) : (
                    <div className="w-full p-6 text-center flex items-center justify-center">
                      Nessun elenco di Bevande disponibile
                    </div>
                  )} */}
                </div>
              )}
              {/* <div className="w-full mb-2 mt-5 py-3 flex items-center justify-start flex-wrap gap-4">
                    {beverageData?.length > 0 ? (
                      // beverageData?.menus?.map((beverage, index) => (
                      <div
                        // key={index}
                        onClick={() => navigate(`/restaurant/${rest_name}/beverage-list/${restData?.restaurant?.id}`)}
                        className="spinja-font cursor-pointer px-[30px] py-[8px] shadow bg-[#EEDEE0] border-[#8B2433] text-center flex items-center justify-center rounded-[40px]"
                      >
                        <h1 className="spinja-font text-[17px] resto-first leading-[26px] break-words font-medium text-[#000000]">
                          Beverage(Other wine)
                        </h1>
                      </div>
                      // )
                    ) : (
                      <div className="w-full p-6 text-center flex items-center justify-center">
                        Nessun elenco di Bevande disponibile
                      </div>
                    )}
                  </div> */}
              {/* </div>
              ) } */}

              {/* Back Button  */}
              <div className="w-full flex justify-center mt-7 mb-4">
                {(userType === "admin" || userType === "restaurant") && (
                  <button
                    className="flex items-center px-2 py-1 bg-[#8A2533] text-white rounded-lg border-2 border-[#953543] hover:text-[#8A2533] hover:bg-[#f6efef] transition-colors group"
                    onClick={() => navigate(
                      userType === "admin"
                        ? "/admin/restaurantManagement"
                        : `/restaurantPanel/restaurantManagement/${restData?.restaurant?.id}`
                    )}
                  >
                    <IoIosArrowBack size={"25px"} color="white" className="group-hover:invert" />
                    <span className="ml-2 poppins-regular">{t('landingPage.backButton')}</span>
                  </button>
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default LandingPage;